import { autoRegisterFeature } from '@store/features/factory';

import { patientDeduplicationFeature } from './store/feature';

autoRegisterFeature(patientDeduplicationFeature);

// Export page components
export { MergeCustomizationPage } from './MergeCustomizationPage';
export { PatientDeduplicationPage } from './PatientDeduplicationPage';
export * from './store';
export * from './types';
